import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API, ApiAdmin } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
export default function EmpolyeeAdd() {
  const navigate = useNavigate();
  const [errors, Seterrors] = useState("");
  const [Action, SetAction] = useState("AddCompanyInfo");
  const [Inputs, setInputs] = useState([
    {
      Name: "1",
      NameEn: "2",
      Address: "3",
      Mobil: "4",
      Email: "5",
      WhatsApp: "6",
      TekTok: "7",
      Youtube: "8",
      CommercialRegister: "9",
      TaxCard: "10",
      Description: "11",
    },
  ]);
  console.log(Inputs);
  //---------ShowModal----------------------------
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  //===========Check Login ================
  LoginCheck();
  var admininfo = [
    {
      AdminName: "",
      AdminID: "",
    },
  ];
  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Data, SetData] = useState([]);
  useEffect(() => {
  }, []);
  //-------------------------------------------------------------
  async function GetData() {
    try {
      const post = {
        Action: "GetCompanyInfo",
      };
      const response = await fetch(ApiAdmin + "/CompanyInfo.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
      SetData(data[0]);
      setInputs(data[0]);
    } catch (error) {
      return error;
    }
  }
  //-------------------------------------------------------------
  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //--------------------------------
  const handleDubelClick = (e) => {
    const name = e.target.name;
    const value = "";
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //----------------------

  const handleSubmit = async (e) => {
    e.preventDefault();

    //====================================
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());

    if (window.confirm("هل تريد الحفظ   ")) {
      try {
        const response = await fetch(ApiAdmin + "/Employees.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          Seterrors(data.errors);
          handleShowModal();
        }
        if (data.msg != "") {
          Seterrors(data.msg);
          handleShowModal();
          // GetData();
          // e.target.reset();
        }
        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  //===================================
  // async function handeldeleteName(id, Name) {
  //   if (window.confirm("هل تريد الحذف")) {
  //     try {
  //       const post = {
  //         Action: "DeleteCompanyInfo",
  //         ID: id,
  //         Name: Name,
  //       };
  //       const response = await fetch(ApiAdmin + "/CompanyInfo.php", {
  //         method: "POST",
  //         body: JSON.stringify(post),
  //       });
  //       const data = await response.json();
  //       console.log(data);
  //       GetData();
  //     } catch (error) {
  //       return error;
  //     }
  //   }
  // }

  return (
    <>
      <Header_ />
      <form method="POST" onSubmit={handleSubmit}>
        <div
          dir="rtl"
          className="row p-0 mt-0 text-end m-auto bg-white mt-lg-4 shadow"
          style={{ maxWidth: "600px" }}
        >
          <h3 className="text-orange fw-bold py-1 mt-2">
            <Link to="../admin/Empolyee">
              <i className="fa-solid fa-chevron-right text-orange bg-light p-1 mx-2 fs-4"></i>
            </Link>
            {"اضافة بيانات الموظفين"}
          </h3>
          <input type="hidden" name="Action" value="AddEmployees" />
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              الاسم
            </label>
            <input
              type="text"
              name="Name"
              className="form-control"
              autoComplete="off"
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Name}
            />
          </div>
          <div className="col-lg-12 col-12">
            <label className="col-form-label"> العنوان</label>
            <input
              type="text"
              name="Address"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Address}
            />
          </div>
          <div className="col-lg-4 col-12">
            <label className="col-form-label" autoComplete="off">
              رقم البطاقة
            </label>
            <input
              type="text"
              name="Card"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Card}
            />
          </div>
          <div className="col-lg-4 col-12">
            <label className="col-form-label"> رقم الموبايل</label>
            <input
              type="text"
              name="Mobail"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Mobail}
            />
          </div>
          <div className="col-lg-4 col-12">
            <label className="col-form-label" autoComplete="off">
              تاريخ الميلاد
            </label>
            <input
              type="date"
              name="Age"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Age}
            />
          </div>
          <div className="col-12">
            <label className="col-form-label" autoComplete="off">
              الوظيفة
            </label>
            <input
              type="text"
              name="Job"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Job}
            />
          </div>
      
          <div className="col-lg-6 col-6">
            <label className="col-form-label" autoComplete="off">
              تاريخ التوظيف
            </label>
            <input
              type="date"
              name="DateJob"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.DateJob}
            />
          </div>
      
          <div className="col-6">
            <label className="col-form-label" autoComplete="off">
              المرتب
            </label>
            <input
              type="text"
              name="Selary"
              className="form-control"
              autoComplete="off"
              placeholder=""
              onClick={handleDubelClick}
              onChange={handleChange}
              value={Inputs.Selary}
            />
          </div>

          <div className="col-12 mt-4 text-center">
            <button className="btn btn-success px-4 w-50">SAVE</button>
          </div>
          <br />
          <br />
          <br />
          <br />
        </div>
      </form>
      <MSG />
    </>
  );

  function MSG() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <div className="row">
              <div className="col-12 text-center">
                <h4 className="text-start p-0 m-0">خطا </h4>
                <hr />
                <h5 className=" text-center ">{errors}</h5>
                <button
                  onClick={() => handleCloseModal()}
                  className="btn btn-danger w-50 m-3"
                >
                  OK
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
